<template>
  <div class="page-content-wrapper">
    <div class="card rounded-3 shadow border-1">
      <div class="card-header bg-white border-0">
        <p class="text-s fw-bold">Create Question</p>
      </div>
      <div class="card-body">
        <form @submit.prevent="create_question">
          <div class="row mb-3">
            <div class="col">
              <label class="form-label fw-bold text-xs"
                ><small>Question Type</small></label
              >
              <select
                v-model="create_question_data.question_type"
                class="form-select text-xs rounded-small p-2 shadow-sm"
              >
                <option value="" disabled hidden>Select Type</option>
                <option value="File">File</option>
                <option value="Date">Date</option>
                <option value="Text">Text</option>
                <option value="Checkbox">Checkbox</option>
                <option value="Selection">Selection</option>
                <option value="Number">Number</option>
                <option value="Multi Selection">Multiple Selection</option>
                <option value="Text Area">Text Area</option>
              </select>
              <small
                class="text-danger p-2 text-xxs fw-bold d-none"
                id="question-type-error"
              >
                Please select a value from field
              </small>
            </div>
            <div class="col">
              <label class="form-label fw-bold text-xs"
                ><small>Is question mandatory?</small></label
              >
              <select
                v-model="create_question_data.mandatory"
                class="form-select text-xs rounded-small p-2 shadow-sm"
              >
                <option value="" disabled hidden>Select Option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <small
                class="text-danger p-2 text-xxs fw-bold d-none"
                id="mandatory-field-error"
              >
                Please select a value from field
              </small>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <label class="form-label fw-bold text-xs"
                ><small>Question</small></label
              >
              <textarea
                v-model="create_question_data.question"
                type="text"
                rows="4"
                class="form-control text-xs rounded-small h-50 p-3 shadow-sm"
                placeholder="e.g Are you a director of a company?"
              >
              </textarea>
              <small
                class="text-danger p-2 text-xxs fw-bold d-none"
                id="question-error"
              >
                Please fill in this field
              </small>
            </div>
          </div>

          <!-- Inputs for adding option after select  -->
          <div class="row" v-show="check_question_type">
            <h6 class="fw-bold mt-2">Add Options If Applicable</h6>
            <div v-if="check_question_type" class="col-6 mb-3">
              <div class="mb-3">
                <label
                  for="number_of_options"
                  class="form-label fw-bold text-xs"
                  ><small
                    ><span>
                      Enter number of options for your question</span
                    ></small
                  >
                </label>
                <input
                  class="form-control text-xs rounded-small p-3 shadow-sm"
                  type="number"
                  id="number_of_options"
                  min="1"
                  v-model="create_question_data.number_of_options"
                  @input="validate_number_of_options"
                  placeholder="Enter number of options"
                />
              </div>
              <!-- Options container with scrolling -->
              <div class="options-container mt-3 options-scroll">
                <div
                  v-for="(option, index) in create_question_data.options"
                  class="mb-2"
                  :key="option.id"
                >
                  <input
                    class="form-control text-xs rounded-small p-3 shadow-sm options"
                    type="text"
                    v-model="create_question_data.options[index]"
                    :placeholder="`Option ${index + 1}`"
                  />
                </div>
              </div>
              <small
                class="text-danger p-2 text-xxs fw-bold d-none"
                id="option-field-error"
              >
                Please fill all options
              </small>
            </div>
            <div v-show="check_question_type" class="col-6 mb-3 hide_field">
              <label for="other_field" class="form-label fw-bold text-xs"
                ><small
                  >Do you have an extra field for <span>other</span> options?
                  *</small
                ></label
              >
              <select
                class="form-select text-xs rounded-small p-2 shadow-sm"
                aria-label="other_field"
                name="other_field"
                id="other_field"
              >
                <option hidden selected value="">Select Option</option>
                <option value="False">No</option>
                <option value="True">Yes</option>
              </select>
              <small
                class="text-danger p-2 text-xxs fw-bold d-none"
                id="additional-field-error"
                >Please select a value from field</small
              >
            </div>
          </div>
          <div class="col text-end">
            <button
              type="submit"
              class="btn bg-green btn-sm text-white text-xxs fw-bold rounded-3 mt-3 shadow-sm"
            >
              Create Question
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="card rounded-3 border-1 shadow mt-4">
      <div class="card-header bg-white border-0">
        <p class="text-s fw-bold">Manage Questions</p>
      </div>
      <div class="card-body">
        <CustomTable
          :columns="columns"
          :fetchData="get_questions"
          :key="table_key"
          :hasActions="true"
          tableKey="system_questions"
        >
          <template v-slot:cell-question="{ row }">
            <span class="text-xxs">{{ row.question }}</span>
          </template>
          <template v-slot:cell-question_type="{ row }">
            <span class="text-xxs">{{ row.question_type }}</span>
          </template>
          <template v-slot:cell-options="{ row }">
            <span v-if="row.options && row.options.length > 0" class="text-xxs">
              <div class="td-options">
                <div v-for="item in row.options" :key="item.id">
                  {{ item.option || "" }}
                </div>
              </div>
            </span>
            <span v-else class="text-xxs">None</span>
          </template>
          <template v-slot:actions="{ row }">
            <button
              v-if="row"
              class="btn btn-dark rounded-3 fw-bold btn-sm me-2 text-xxs text-white"
              @click="edit_question(row)"
            >
              Edit
            </button>
            <button
              v-if="row && row.is_active"
              class="btn btn-danger rounded-3 fw-bold btn-sm me-2 text-xxs text-white"
              @click="deactivate_question(row.id)"
            >
              Deactivate
            </button>
            <button
              v-else-if="row && !row.is_active"
              class="btn bg-success text-white rounded-3 fw-bold btn-sm me-2 text-xxs"
              @click="activate_question(row.id)"
            >
              Activate
            </button>
            <button
              v-if="
                row &&
                (row.question_type === 'Selection' ||
                  row.question_type === 'Checkbox' ||
                  row.question_type === 'Multi Selection')
              "
              class="btn btn-dark rounded-3 fw-bold btn-sm me-2 text-xxs text-white align-items-center"
              @click="redirect_to_conditional_questions(row.id)"
            >
              Add Conditions
            </button>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Edit question Modal -->
    <div
      class="modal fade"
      id="edit_question_modal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="edit_question_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white">
          <div class="modal-header border-bottom-0">
            <h5
              class="modal-title text-s fw-bold"
              id="edit_question_modal_label"
            >
              Edit Question Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col mb-4">
              <label class="form-label fw-bold text-xs"
                ><small>Question</small></label
              >
              <textarea
                v-model="edit_question_data.question"
                type="text"
                class="form-control text-xs rounded-small h-50 p-3 shadow-sm"
                rows="4"
                required="True"
                placeholder="e.g Are you a director of a company?"
              >
              </textarea>
            </div>
            <div class="col mb-4">
              <label class="form-label fw-bold text-xs"
                ><small>Is Mandatory</small></label
              >
              <select
                v-model="edit_question_data.mandatory"
                class="form-select text-xs rounded-small p-2 shadow-sm"
              >
                <option value="" disabled hidden>Select Type</option>
                <option
                  :value="true"
                  v-if="edit_question_data.mandatory === true"
                >
                  Yes
                </option>
                <option
                  :value="false"
                  v-if="edit_question_data.mandatory === false"
                >
                  No
                </option>
                <option value="False">No</option>
                <option value="True">Yes</option>
              </select>
            </div>
            <div class="col mb-4">
              <label class="form-label fw-bold text-xs"
                ><small>Question Type</small></label
              >
              <select
                v-model="edit_question_data.question_type"
                class="form-select text-xs rounded-small p-2 shadow-sm"
              >
                <option value="" disabled hidden>Select Type</option>
                <option value="File">File</option>
                <option value="Date">Date</option>
                <option value="Text">Text</option>
                <option value="Checkbox">Checkbox</option>
                <option value="Selection">Selection</option>
                <option value="Number">Number</option>
                <option value="Multi Selection">Multiple Selection</option>
                <option value="Text Area">Text Area</option>
              </select>
            </div>
            <div v-show="check_edit_question_type" class="mb-4">
              <h6 class="text-sm fw-bold">Edit Options If Applicable</h6>
              <div class="mb-3">
                <label
                  for="edit_number_of_options"
                  class="form-label text-xs fw-bold"
                >
                  <small>Enter number of options for your question</small>
                </label>
                <input
                  class="form-control text-xs rounded-small p-3 shadow-sm"
                  type="number"
                  id="edit_number_of_options"
                  min="1"
                  v-model="edit_question_data.number_of_options"
                  @input="edit_validate_number_of_options"
                  placeholder="Enter number of options"
                />
              </div>

              <!-- Scrollable options container for edit modal -->
              <div class="options-container options-scroll">
                <div
                  v-for="(option, index) in edit_question_data.options"
                  :key="option.id"
                  class="mb-2"
                >
                  <input
                    class="form-control text-xs rounded-small p-3 shadow-sm"
                    type="text"
                    :id="'edit_option_' + index"
                    v-model="edit_question_data.options[index]"
                    :placeholder="`Option ${index + 1}`"
                  />
                </div>
              </div>
            </div>
            <div class="col text-end">
              <button
                type="submit"
                class="btn bg-green btn-sm text-xs fw-bold rounded-small shadow-sm mt-3"
                @click="update_question"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./question_management.js"></script>
